import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid';
import { Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
const VoucherSellSummarySection = ({

    grossAmount,
    discountPercentage,
    setDiscountPercentage,
    discountAmount,
    netAmount,
    disable


}) => {


    return (
        <React.Fragment>
            <Col sm={12} md={6} className="mb-12-sm "></Col>
            <Col sm={12} md={6} className="mb-12-sm ">
                <Row className='d-flex justify-content-end'>

                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Gross Amount
                            </Label>
                        </Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            disabled={true}
                            textAlign="right"
                            value={parseFloat(grossAmount).toFixed(2)}


                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Discount(%) {"[" + DecimalValidation(discountAmount) + "]"}
                            </Label>
                        </Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            textAlign="right"
                            value={discountPercentage}
                            disabled={disable}
                            onChange={(e) => {
                                var value = Numeric(e.target, 5, 2, false);

                                if (value > 100) {
                                    value = 100;
                                } else if (value < 0) {
                                    value = 0;
                                }

                                setDiscountPercentage(value)
                            }}
                            onBlur={(e) => {
                                var val = DecimalValidation(e.target.value)
                                setDiscountPercentage(val)
                            }}
                            onKeyPress={async (e) => {
                                if (e.key === "Enter") {
                                    if (e.target.value == "") {
                                        setDiscountPercentage(0)
                                    } else {
                                        setDiscountPercentage(parseFloat(e.target.value))
                                    }
                                }
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
                {/* <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Additions
                            </Label>
                        </Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            textAlign="right"

                        ></DPTextBoxforgrid>
                    </Col>
                </Row> */}
                {/* <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Deductions
                            </Label>
                        </Label>
                    </Col>

                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            textAlign="right"

                        ></DPTextBoxforgrid>
                    </Col>
                </Row> */}
                {/* <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">

                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Tax(Inclusive)
                            </Label></Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            disabled={true}
                            textAlign="right"

                        ></DPTextBoxforgrid>
                    </Col>
                </Row> */}
                {/* <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Tax(Exclusive)
                            </Label>
                        </Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            disabled={true}
                            textAlign="right"

                        ></DPTextBoxforgrid>
                    </Col>
                </Row> */}
                <Row className='d-flex justify-content-end'>
                    <Col sm={4}>
                        <Label htmlFor="example-text-input">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm mb-0`}
                            >
                                Net Amount
                            </Label>
                        </Label>
                    </Col>
                    <Col sm={4} style={{ textAlign: "right" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            textType="text"
                            maxLength="8"
                            disabled={true}
                            textAlign="right"
                            value={DecimalValidation(netAmount)}

                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </Col>
        </React.Fragment>
    )

};

export default VoucherSellSummarySection;